export const getOrganizationReference = (orgCode: string): { code: string; display: string } => {
  return { code: orgCode.toUpperCase(), display: orgCode.toLowerCase() };
};
